<template>
	<div id="app">
		<!-- <input v-model="modalTitle">
		<input v-model="modalMessage">
		<button @click="testModal('error')">Error</button>
		<button @click="testModal('loading')">Loading</button>
		<button @click="testModal('success')">Success</button>
		<button @click="testModal('info')">Info</button> -->

		<!-- The Modal -->
		<div class="modal" id="wnModalGlobal">
			<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">

				<!-- Modal Header -->
				<div id="a123" v-if="modal.type=='error'" class="modal-header alert-danger">
					<h4 class="modal-title" :key="'modal-title-'+modal.type">
						<i class="fas fa-exclamation-circle"></i>
						ERROR: {{modal.title || "(unknown)"}}
					</h4>
				</div>
				<div id="b123" v-else-if="modal.type=='loading'" class="modal-header alert-secondary">
					<h4 class="modal-title" :key="'modal-title-'+modal.type">
						<img src="static/img/loading-buffering.gif" style="height: 24px; margin-top: -4px;">
						Loading {{modal.title || "..."}}
					</h4>
				</div>
				<div id="c123" v-else-if="modal.type=='success'" class="modal-header alert-success">
					<h4 class="modal-title" :key="'modal-title-'+modal.type">
						<i class="fas fa-check-circle"></i>
						{{modal.title || "Success!"}}
					</h4>
				</div>
				<div id="d123" v-else class="modal-header alert-info">
					<h4 class="modal-title" :key="'modal-title-'+ ( modal.type || 'info' )">
						<i class="fas fa-info-circle"></i>
						{{modal.title}}
					</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>

				<!-- Modal body -->
				<div class="modal-body">
					{{modal.message}}
				</div>

				<!-- Modal footer -->
				<!-- <div class="modal-footer">
					<button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
				</div> -->

				</div>
			</div>
		</div>
		<header class="border-bottom border-dark shadow-sm p-3 px-md-4 mb-3">
			<!--<h5 class="my-0 mr-md-auto font-weight-normal">Company name</h5>-->
			<div class="container-fluid mx-auto d-flex flex-column flex-md-row align-items-center">
				<div class="my-0 mr-md-auto text-nowrap">
					<!--<img src="img/logo-new.png" class="logo-icon"><img src="img/logo-text-grey.png" class="logo-text">-->
					<a href="#/"><img src="static/img/wn-logo-icon.png" class='wn-logo-icon'><img
							src="static/img/wn-logo-text.png" class='wn-logo-text'></a>
				</div>

				<nav class="my-2 my-md-0 mr-md-3">
					<router-link v-if="homeNode" class="p-2 text-light" :to="'/nodes/'+homeNode.$id">Home Node</router-link>
					<router-link class="p-2 text-light" :to="'/nodes/'">Ecosystem</router-link>
					<router-link class="p-2 text-light" :to="'/release/'">Release</router-link>
					<router-link class="p-2 text-light" :to="'/welcome/'">About</router-link>
					<!-- <a class="p-2 text-light" href="#">Support</a>
					<a class="p-2 text-light" href="#">Community</a> -->
				</nav>
				<div v-if="!loggedIn" class="btn-group">
					<a class="btn btn-outline-light btn-light" href="javascript:void(0)" @click.prevent="login"><i class="fas fa-sign-in-alt"></i> Login</a>
					<!-- <a class="btn btn-outline-light btn-light" href="javascript:void(0)"><i class="fas fa-user-plus"></i> Sign up</a> -->
					<router-link class="btn btn-outline-light btn-light" to="/release"><i class="fas fa-user-plus"></i> Sign up</router-link>
				</div>
				<div v-if="loggedIn" class="btn-group">
					<router-link class="btn btn-outline-light btn-light" :to="'/nodes/'+ nodeId +'/accounts/'+ currentSession.account"><i class="fas fa-user-cog"></i> Account</router-link>
					<a class="btn btn-outline-light btn-light" href="javascript:void(0)" @click.prevent="unsetActiveSession"><i class="fas fa-sign-out-alt"></i> Logout</a>
				</div>
			</div>
		</header>
		<nav class="bread p-3 px-md-4 mb-3 bg-white border-bottom shadow-sm" v-if="navBreadcrumb.length > 0">
			<ol class="list-inline container-fluid">
				<li class="list-inline-item"><a href="#/"><i class="fas fa-home"></i></a></li>
				<li class="list-inline-item" v-for="( item, index ) in navBreadcrumb" :key="item.path">
					<i class="fas fa-angle-right"></i><router-link v-if="navBreadcrumb.length > ( index + 1 )" :to="item.path">{{item.name}}</router-link><span v-if="navBreadcrumb.length === ( index + 1 )">{{item.name}}</span>
				</li>
			</ol>
		</nav>

		<!--
		<div style="border-bottom: 1px solid #999;">
			<form v-if="loggedIn" v-on:submit.prevent="unsetActiveSession">
				Session: {{currentSession.account}} ({{nodeId}}) <button type="submit">Logout</button>
			</form>
		</div>
		-->
		<router-view v-if="initialized" :key="$route.path"/>
		<!-- <hr>
		<ul class="breadcrumb">
			<li><strong>Quick Links: </strong></li>
			<li><router-link to="/nodes">Nodes</router-link></li>
			<li> | <router-link to="/nodes/mongo_1">Node (mongo_1)</router-link></li>
			<li> | <router-link to="/nodes/mongo_1/projects">Projects</router-link></li>
			<li> | <router-link to="/nodes/mongo_1/projects/wojtektest">Sample Project 1</router-link></li>
			<li> | <router-link to="/nodes/mongo_1/projects/wojtektest/collections">Collections</router-link></li>
		</ul>
		<ul class="breadcrumb">
			<li><strong>Root Links: </strong></li>
			<li><router-link to="/welcome">Welcome</router-link></li>
			<li> | <router-link to="/authentication">Authentication</router-link></li>
			<li> | <router-link to="/nodes">Ecosystem (Nodes)</router-link></li>
		</ul> -->
		
		<footer class="pt-2 my-md-3 pt-md-3 border-top">
			<div class="container-fluid mx-auto">
				<div class="row">
					<div class="col mb-3 text-center">
						<ul class="list-inline mb-0">
							<li class="list-inline-item"><a class="text-small" href="https://www.facebook.com/WidenodeInc"><i class="fab fa-facebook mr-2"></i>facebook.com/WidenodeInc</a></li>
							<li class="list-inline-item"><a class="text-small" href="https://twitter.com/WidenodeInc"><i class="fab fa-twitter mr-2"></i>twitter.com/WidenodeInc</a></li>
							<li class="list-inline-item text-small"><i class="fas fa-at mr-1"></i><img src="static/img/widenode-email.png"></li>
						</ul>
					</div>
				</div>
				<div class="row">
					<div class="col mb-3 text-muted text-center">
						<small>&copy; 2017-{{currentYear}} Widenode Inc. Widenode and the Widenode logo are trademarks (&trade;) of Widenode Inc.</small>
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import Cookie from 'js-cookie';
import { setInterval, clearInterval } from 'timers';
import _ from "lodash";
import { updateBreadcrumb } from '../util';
import { EventBus } from '@/eventBus';

export default {
	name: 'app-view',
	data() {
		return {
			suppressAuthRedirect: false,
			navBreadcrumb: [],
			initialized : false,
			routeParams : this.$route.params,
			currentYear : ( new Date( ) ).getFullYear( ),
			modalTitle : "",
			modalMessage : "",
			modal : {
				title : "",
				message : "",
				type : "info"
			},
			EventBus
		};
	},
	watch : {
		'$route.path' : function( newValue, oldValue )
		{
			this.navBreadcrumb = updateBreadcrumb( this.$route );
			//this.checkLogin( );
			this.$store.dispatch( "authentication/checkSession", { nodeId : ( this.$route.params.nodeId || null ) } );
		},
		'routeParams.forceLogin'( newVal, oldVal )
		{
			console.log( "WORKS", newVal, oldVal );
		}
	},
	computed: {
		nodeId : function( ) {
			return this.$route.params.nodeId || null;
		},
		loggedIn : function( )
		{
			return !!this.currentSession;
		},
		currentSession : function( )
		{
			try {
				return this.session( this.activeSession( this.nodeId ) );
			} catch( err ) {
				return null;
			}
		},
		sessionData : function( ) {
			if( this.currentSession )
				return JSON.stringify( this.currentSession );
			return "{}";
		},
		...mapGetters( "authentication", [
			"activeSession",
			"session"
		]),
		...mapGetters( "nodes", {
			getNode: "node", // map STATE projects/all to "projects" AS A FUNCTION, which requires the nodeId as input!
			homeNode: "homeNode",
			parentNode: "parent",	// FUNCTION
		}),
	},
	methods: {
		testModal( event ) {
			EventBus.$emit( "modal", {
				type: event,
				title: this.modalTitle,
				message: this.modalMessage
			});
		},
		login( )
		{
			if( !this.nodeId )
			{
				alert( "In order to Sign In, first select a node." );
				this.$router.replace( { name : 'nodes' } );
			}
			this.$set( this.$route.params, 'forceLogin', true );
		},
		checkLogin( loggedIn )
		{
			console.log( "!!!! CHECK LOGIN !!!!" );
			if( !this.initialized )
				return;
			
			if( typeof loggedIn === 'undefined' )
				loggedIn = this.loggedIn;
			if( !this.suppressAuthRedirect && !loggedIn && true !== this.$route.meta.public )
			{
				let route = _.pick( this.$route, [ 'name', 'params' ] );
				this.$router.replace( { name : 'authentication', params : { authRedirect : route, nodeId : this.$route.params.nodeId } } );
			}
		},
		async logout( )
		{
			this.suppressAuthRedirect = true;
			try {
				await this.$store.dispatch( "authentication/logout", { nodeId : this.nodeId, sessionKey : this.currentSession.$id } );
			} catch( err ) {
				console.warn( "Logout failed: "+ err.message );
			}
		},
		unsetActiveSession( )
		{
			this.$delete( this.$route.params, 'forceLogin' );
			this.$store.commit( 'authentication/setActiveSession', { nodeId : this.nodeId, sessionGuid : null } );
		}
	},
	beforeCreate( )
	{
		this.$store.dispatch( "authentication/checkSession", { } )
			.then( result => {
				if( result ) console.log( "[App] Session Restored!" );
				else console.log( "[App] No session to restore." );
			})
			.catch( error => { console.log( "[App] Failed to restore session:", error ) } )
			.finally( ( ) => {
				console.log( "[App] INITIALIZED" );
				this.initialized = true;
				//this.checkLogin( );
			} );
	},
	created( )
	{
		// TODO: Enable this for PROD
		// this.heartbeatInterval = setInterval(
		//  	( function( ) {
		// 		if( this.loggedIn )
		//  			this.$store.dispatch( "authentication/checkSession", { } );
		//  	}).bind(this), 10000 );
		this.navBreadcrumb = updateBreadcrumb( this.$route );
		//this.checkLogin( );

		EventBus.$on( 'modal', ({ title = "", message = "", type = "message" }) =>
		{
			if( type == "close" )
				return $('#wnModalGlobal').modal('hide');

			this.$set( this.modal, 'type', type );
			this.$set( this.modal, 'title', title );
			this.$set( this.modal, 'message', message );

			$('#wnModalGlobal').modal('show');
		});
	},
	destroyed( )
	{
		// TODO: Enable this for PROD
		// try {
		// 	clearInterval( this.heartbeatInterval );
		// } catch( err ) {
		// 	console.warn( "Warning: Heartbeat interval with ID ["+ this.heartbeatInterval +"] was not found." );
		// }
	}
}
</script>



// WEBPACK FOOTER //
// src/components/App.vue